module.exports = __webpack_public_path__ + "static/media/FormatoSimplificado_316307.850970ad.pdf";


//////////////////
// WEBPACK FOOTER
// ./src/media/ift/InternetAlTFF/FormatoSimplificado_316307.pdf
// module id = 330
// module chunks = 0